var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrepareTicket = function SvgPrepareTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8205 17.0047C19.045 16.9894 10.2599 17.0164 1.49187 17.0164C0.667993 17.0164 0.000244141 17.6842 0.000244141 18.508C0.000244141 19.3318 0.667993 19.9996 1.49187 19.9996H3.42431V23C3.42431 26.4322 6.21316 29 9.64528 29H22.4445C25.8766 29 28.6653 26.4322 28.6653 23V19.9996H30.5086C31.3324 19.9996 32.0002 19.3318 32.0002 18.508C32.0002 17.6842 31.3324 17.0164 30.5086 17.0164H27.8787C27.8589 17.0154 27.8414 17.0047 27.8205 17.0047Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7367 3C13.7435 3 12.916 3.83234 12.916 4.83157V6.94901H10.9593C6.85814 6.94901 3.47342 10.0293 3.00641 14.0177C2.94494 14.5408 3.35117 15.0006 3.87473 15H28.1257C28.6492 15.0005 29.0557 14.5408 28.994 14.0177C28.5269 10.0294 25.1402 6.94901 21.039 6.94901H19.0823V4.83157C19.0823 3.83233 18.2569 3 17.2637 3H14.7367Z",
    fill: "currentColor"
  })));
};
export default SvgPrepareTicket;